import { makeStyles } from "@material-ui/styles"

const styles = makeStyles(theme => ({
  emailActionButton: {
    color: theme.palette.primary.main + "!important"
  },
  tagChip: {
    marginRight: "5px",
    backgroundColor: "#ADB4FF"
  },

  tableContainer: {
    "& .MuiTableCell-body": {
      padding: "0px",
      paddingLeft: theme.spacing(2)
    },
    "& .MuiTable-root": {
      borderCollapse: "unset"
    },
    "& .MuiTableSortLabel-root.MuiTableSortLabel-active": {
      color: "#71338C"
    }
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/pages/Admin/pages/Communication/CommunicationEmail/CommunicationEmailTable/styles.js